import utils from "../../../utils/utils";
export default {
    async fetchMineReports(context, payload) {
        const response = await utils.utility.fetch(`api/Report/GetMineReports?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);                
        context.commit("setMineReports", response.data);
    },
    async fetchReportCenterReports(context, payload) {
        const response = await utils.utility.fetch(`api/Report/GetReportCenterReports?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);                
        context.commit("setReportCenterReports", response.data);
    },
    async fetchOtherReports(context, payload) {
        const response = await utils.utility.fetch(`api/Report/GetOtherReports?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);                
        context.commit("setOtherReports", response.data);
    },
    async fetchUpsertDefinition(context, payload) {
        const response = await utils.utility.fetch(`api/Report/GetReportDefinition?reportId=${payload}`);                
        context.commit("setUpsertDefition", response.data);
    },
    async deleteReport(_,payload){
        await utils.utility.fetch("api/Report/DeleteReport","PUT",null, {reportId:payload});        
    },
    async toggleHidingReport(_,payload){
        await utils.utility.fetch("api/Report/ToggleHidingReport","PUT",null, {reportId:payload});        
    },
    async upsertReport(_,payload){        
        await utils.utility.fetch("api/Report/AddOrUpdateReport","POST",null, payload);  
    },
    async copyReport(_,payload){
        await utils.utility.fetch("api/Report/CopyReport","POST",null, {reportId:payload});  
    },
    async fetchReportFeeds(context,payload){                  
        const response = await utils.utility.fetch(`api/Report/GetReportFeeds`, "POST", null, payload);                     
        context.commit("setReportFeeds",response.data);
    },
    async fetchExportReportFeeds(_,payload){                          
        await utils.utility.fetch(`api/Report/GetExportReportFeeds`, "POST", null, payload);                             
    },
    async fetchUniqueAuthorChart(context,payload){        
        const response = await utils.utility.fetch(`api/Report/GetUniqueAuthorChart`, "POST", null, payload);                     
        context.commit("setUniqueAuthorChart",response.data);
    },
    async fetchEngagements(context,payload){        
        const response = await utils.utility.fetch("api/Report/GetReportEngagements","POST",null,payload);                   
        context.commit("setEngagements",response.data);
    },
    async fetchCategoryRates(context,payload){        
        const response = await utils.utility.fetch(`api/Report/GetCategoryRates`, "POST", null, payload);                     
        context.commit("setCategoryRates",response.data);
    },
    async fetchSentimentChart(context,payload){        
        const response = await utils.utility.fetch(`api/Report/GetSentimentChart`, "POST", null, payload);                     
        context.commit("setSentimentChart",response.data);
    },
    async fetchSocialMediaRates(context,payload){        
        const response = await utils.utility.fetch(`api/Report/GetSocialMediaRates`, "POST", null, payload);                     
        context.commit("setSocialMediaRates",response.data);
    },
    async fetchInteractionChart(context,payload){        
        const response = await utils.utility.fetch(`api/Report/GetTotalInteractionChart`, "POST", null, payload);                     
        context.commit("setInteractionChart",response.data);
    },
    async fetchTalkRateChart(context,payload){        
        const response = await utils.utility.fetch(`api/Report/GetTalkRateChart`, "POST", null, payload);                     
        context.commit("setTalkRateChart",response.data);
    },
    async fetchLocationChart(context,payload){        
        const response = await utils.utility.fetch(`api/Report/GetLocationFeedCountChart`, "POST", null, payload);                     
        context.commit("setLocationChart",response.data);
    },
    async increaseReportViewCount(_,payload){
        const queryParams = utils.utility.getQueryParams(payload);
        await utils.utility.fetch(`api/Report/IncreaseReportViewCount?${queryParams}`, "PUT", null, null);                             
    }      

}